import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function CTA({ onOpenModal }) {
  const { lang, t } = useLang();
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error(
        lang === "cs"
          ? "Zadejte platný e-mail."
          : "Please enter a valid email.",
      );
      return;
    }
    if (onOpenModal) {
      onOpenModal(email);
      setEmail("");
    }
  };

  return (
    <section
      data-testid="cta-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div
          data-testid="cta-banner"
          className="relative overflow-hidden bg-[#22C55E] rounded-[2.5rem] md:rounded-[3rem] px-8 py-14 md:px-16 md:py-20 grid lg:grid-cols-12 gap-10 items-center"
        >
          {/* Decorative blobs */}
          <div
            aria-hidden
            className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-white/10 blur-2xl"
          />
          <div
            aria-hidden
            className="absolute -bottom-32 -left-20 w-80 h-80 rounded-full bg-[#F59E0B]/20 blur-2xl"
          />
          <div
            aria-hidden
            className="absolute top-8 right-8 w-16 h-16 rounded-full bg-[#F59E0B] hidden md:block"
          />

          {/* Copy */}
          <div className="relative lg:col-span-7">
            <h2
              data-testid="cta-title"
              className="font-heading text-4xl md:text-5xl lg:text-6xl font-black tracking-tight text-white leading-[1.05]"
            >
              {t.cta.title}
            </h2>
            <p
              data-testid="cta-subtitle"
              className="mt-5 max-w-xl font-body text-lg md:text-xl text-white/90 leading-relaxed"
            >
              {t.cta.subtitle}
            </p>
          </div>

          {/* Form */}
          <form
            data-testid="cta-form"
            onSubmit={handleSubmit}
            className="relative lg:col-span-5"
          >
            <div className="bg-white rounded-full p-1.5 flex items-center shadow-xl shadow-green-900/20">
              <input
                data-testid="cta-email-input"
                type="email"
                placeholder={t.cta.input_placeholder}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-transparent px-5 py-3 outline-none font-body text-base text-[#064E3B] placeholder:text-[#047857]/50"
                required
              />
              <button
                data-testid="cta-submit-btn"
                type="submit"
                className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-[#064E3B] text-white font-body font-bold text-sm hover:bg-[#22C55E] hover:scale-105 active:scale-95 transition-all duration-300"
              >
                {t.cta.button}
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
            <p
              data-testid="cta-micro"
              className="mt-3 font-body text-sm text-white/80 ml-2"
            >
              {t.cta.micro}
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}
